var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.6743C15.75 12.6743 14.55 12.4743 13.43 12.1043C13.08 11.9943 12.69 12.0743 12.41 12.3443L10.21 14.5443C7.38 13.1043 5.06 10.7943 3.62 7.95432L5.82 5.74432C6.1 5.48432 6.18 5.09432 6.07 4.74432C5.7 3.62432 5.5 2.42432 5.5 1.17432C5.5 0.624316 5.05 0.174316 4.5 0.174316H1C0.45 0.174316 0 0.624316 0 1.17432C0 10.5643 7.61 18.1743 17 18.1743C17.55 18.1743 18 17.7243 18 17.1743V13.6743C18 13.1243 17.55 12.6743 17 12.6743ZM16 9.17432H18C18 4.20432 13.97 0.174316 9 0.174316V2.17432C12.87 2.17432 16 5.30432 16 9.17432ZM12 9.17432H14C14 6.41432 11.76 4.17432 9 4.17432V6.17432C10.66 6.17432 12 7.51432 12 9.17432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d5f4a920f48193c8e82f89756abeac28.svg";
export { ForwardRef as ReactComponent };